module.exports = __webpack_public_path__ + "img/T4-D-rc_15.2d0cae42.png";